import { useTheme, Box } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { Carousel, CarouselItem } from "components/Carousel"
import { Image } from "../../Image/Image"
import { buildSizes, buildSrcSet } from "utils/image"

export const DEFAULT_MUI_SIZES = buildSizes(
  [
    { maxWidth: 600, size: "40vw" }, // xs
    { maxWidth: 1200, size: "60vw" }, // md
  ],
  "90vw" // lg+
)

const SLIDE_PER_PAGE = 3

export const AdImageCarousel = ({
  data = [],
  onClickSlide = () => {},
  carouselOptions = {},
  sx = {},
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`VuiAdImageCarousel`]?.styleOverrides || {}
  const { root, carousel, carouselItem, image } = styleOverrides
  const carouselType =
    Array.isArray(data) && data.length < SLIDE_PER_PAGE ? "slide" : "loop"

  return (
    <Box sx={deepmerge(root, sx)}>
      <Carousel
        onClick={onClickSlide}
        options={{
          type: carouselType,
          pagination: true,
          autoplay: true,
          perPage: 1,
          interval: 5000,
          focus: "center",
          maxWidth: "100vw",
          ...carouselOptions,
        }}
        sx={carousel}
      >
        {data.map(({ id, mediaSrc, media, url, link }) => {
          return (
            <CarouselItem
              link={url || link}
              key={`slide-${id}`}
              sx={carouselItem}
            >
              <Image
                sx={image}
                src={mediaSrc}
                srcSet={buildSrcSet(media)}
                sizes={DEFAULT_MUI_SIZES}
              />
            </CarouselItem>
          )
        })}
      </Carousel>
    </Box>
  )
}
